import React from 'react'
import {useTranslations} from 'next-intl'
import {css} from '@emotion/react'

import generateId from '../../../../utils/generateId'
import Button from '../../../../components/elements/Button'
import FileDropzone from '../../../../components/modules/FileDropzone'
import BasicDialog from '../../../../components/elements/BasicDialog'
import readTextFromFile from '../../../../utils/readTextFromFile'
import {generateRandomColor} from './utils'


const MaxOptionCount = 20

export default function UploadOptionsDialog({
                                              open,
                                              onClose,
                                              onOptionsChange,
                                            }) {
  const styles = {
    description: css`
      padding: 16px;
      font-size: 1.2rem;
    `,
    actions: css`
      display: inline-flex;
      gap: 8px;
    `
  }

  const t = useTranslations()

  const [fileInput, setFileInput] = React.useState(null)
  const onInputFileChange = React.useCallback(files => {
    if (files.length === 1) {
      setFileInput(files[0])
    } else {
      setFileInput(null)
    }
  }, [setFileInput])

  const parseOptionsData = React.useCallback(() => {
    if (!fileInput) {
      return
    }

    readTextFromFile(fileInput)
      .then(text => {
        const options = text
          .split('\n')
          .slice(0, MaxOptionCount)
          .map(line => ({
            id: generateId(),
            weight: 1,
            color: generateRandomColor(),
            name: line.trim(),
          }))

        onOptionsChange(options)
        onClose()
      })
  }, [fileInput, onOptionsChange, onClose])

  return (
    <BasicDialog
      title={t('draw-lots.upload-options-dialog.title')}
      open={open}
      onClose={onClose}
      actions={<div css={styles.actions}>
        <Button secondary onClick={onClose}>{t('draw-lots.upload-options-dialog.cancel')}</Button>
        <Button disabled={!fileInput}
                onClick={parseOptionsData}>{t('draw-lots.upload-options-dialog.confirm')}</Button>
      </div>}
    >
      <div>
        <div css={styles.description}>
          <div>{t('draw-lots.upload-options-dialog.description')}</div>
        </div>
        <FileDropzone
          acceptedFiles={['*']}
          filesLimit={1}
          onChange={onInputFileChange}
        />
      </div>
    </BasicDialog>
  )
}
